export default __webpack_public_path__ + "static/media/arc-gis-urban.e3bb3303.svg";